
export const analyticsId = {
    PAYROLL_LOAN_REQUEST_STEP_1_VIEW: "PAYROLL_LOAN_REQUEST_STEP_1_VIEW",
    PAYROLL_LOAN_REQUEST_STEP_2_VIEW: "PAYROLL_LOAN_REQUEST_STEP_2_VIEW",
    PAYROLL_LOAN_REQUEST_STEP_3_VIEW: "PAYROLL_LOAN_REQUEST_STEP_3_VIEW",
    PAYROLL_LOAN_REQUEST_STEP_4_VIEW: "PAYROLL_LOAN_REQUEST_STEP_4_VIEW",
    PAYROLL_LOAN_REQUEST_STEP_1_SUCCESS: "PAYROLL_LOAN_REQUEST_STEP_1_SUCCESS",
    PAYROLL_LOAN_REQUEST_STEP_2_SUCCESS: "PAYROLL_LOAN_REQUEST_STEP_2_SUCCESS",
    PAYROLL_LOAN_REQUEST_STEP_3_SUCCESS: "PAYROLL_LOAN_REQUEST_STEP_3_SUCCESS",
    PAYROLL_LOAN_REQUEST_STEP_4_SUCCESS: "PAYROLL_LOAN_REQUEST_STEP_4_SUCCESS",
    PAYROLL_LOAN_REQUEST_WIZARD_ERROR: "PAYROLL_LOAN_REQUEST_WIZARD_ERROR",
    PAYROLL_LOAN_REQUEST_WIZARD_SUCCESS: "PAYROLL_LOAN_REQUEST_WIZARD_SUCCESS",
};


const commonFields = (processType) => {
    return {
        sectionFamily: "banking",
        sectionCategory: "products",
        sectionName: "loans",
        serviceType: "productApplication",
        interactionType: "funnel",
        processType: processType,
    };
};

export const catalogue = {
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_1_VIEW]: (processType) => ({
        ...commonFields(processType),
        event_name: "step_uvp",
        pageName: "/loanContracting/step1/uvp",
        processStep: "step1",
        processDetail: "uvp",
        productName: "personalLoan",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_2_VIEW]: (processType) => ({
        ...commonFields(processType),
        event_name: "step_simulator",
        pageName: "/loanContracting/step2/simulator",
        processStep: "step2",
        processDetail: "simulator",
        productName: "personalLoan",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_3_VIEW]: (processType) => ({
        ...commonFields(processType),
        event_name: "step_summary",
        pageName: "/loanContracting/step3/summary",
        processStep: "step3",
        processDetail: "summary",
        productName: "personalLoan",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_4_VIEW]: (processType) => ({
        ...commonFields(processType),
        event_name: "step_documentation",
        pageName: "/loanContracting/step4/documentation",
        processStep: "step4",
        processDetail: "documentation",
        productName: "personalLoan",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_1_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "uvp",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_2_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "simulator",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_3_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "summary",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_STEP_4_SUCCESS]: () => ({
        event_name: "event_success",
        action: "success",
        format: "steps",
        component: "funnel",
        element: "documentation",
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_WIZARD_ERROR]: ({ errorMessage }, processType) => ({
        ...commonFields(processType),
        event_name: "step_error",
        pageName: "/loanContracting/error",
        processStep: "error",
        errorCategory: "requestNotApproved",
        productName: "personalLoan",
        errorDescription: errorMessage,
    }),
    [analyticsId.PAYROLL_LOAN_REQUEST_WIZARD_SUCCESS]: (processType) => ({
        ...commonFields(processType),
        event_name: "step_success",
        pageName: "/loanContracting/success",
        processStep: "success",
        productName: "personalLoan",
    }),
};
